import { create } from 'zustand';

export const useMicrofrontendStore = create((set) => ({
  listeners: {
    calculator: 0,
  },
  isLoaded: false,
  setLoaded: (key) => {
    set((state) => {
      const newListeners = { ...state.listeners, [key]: 1 };
      const isLoaded = Object.values(newListeners).every(
        (value) => value === 1,
      );
      return {
        listeners: newListeners,
        isLoaded,
      };
    });
  },
  reset: () => {
    set({
      listeners: {
        offers: 0,
        carConfigurator: 0,
        calculator: 0,
      },
      isLoaded: false,
    });
  },
}));
